import { NETWORK_IDS, NETWORKS } from 'lib/constants';

export const SOURCE_IDS = {
  ...NETWORK_IDS,
  listOfUrls: 11,
  singleLink: 12,
};

export const SOURCES: { [id: number]: any } = {
  ...NETWORKS,
  11: {
    title: 'List of urls',
    name: 'listOfUrls',
    id: 11,
  },
  12: {
    title: 'Single link',
    name: 'singleLink',
    id: 12,
  },
};

/*
  For most sources, the sequence is:
  - selectSource -> selectUsername -> importPosts -> showFinish

  For the list of links/single link, the order is:
  - selectSource -> importUrls/singleLink -> showFinish
*/
export const IMPORT_STEPS = {
  selectSource: 1,
  selectUsername: 2,
  importUrls: 3,
  importPosts: 4,
  showFinish: 6,
  singleLink: 7,
  importLinkedin: 8,
};
